module.exports = __webpack_public_path__ + "Uplayplus_LP_carousel_Anno1800_desktop.png";